import { isClerkEnabled } from "./clerk";
import { AUTH_API_URL, authFetch } from "./authFetch";

type ClerkWindow = Window & {
  Clerk?: {
    signOut?: () => Promise<void>;
  };
};

/**
 * Clear the Drivenow JWT (httpOnly cookie + localStorage dual-mode) and, when
 * Clerk social login is enabled, also end the Clerk browser session so the
 * next "Continue with Google" cannot silently re-auth as the previous user
 * on a shared device.
 */
export async function performLogout(removeToken: () => void): Promise<void> {
  try {
    await authFetch(`${AUTH_API_URL}/logout`, { method: "POST" });
  } catch (err) {
    console.warn("Session cookie logout failed:", err);
  }

  removeToken();

  if (isClerkEnabled()) {
    try {
      const clerk = (window as ClerkWindow).Clerk;
      if (clerk?.signOut) {
        await clerk.signOut();
      }
    } catch (err) {
      console.warn("Clerk signOut failed during logout:", err);
    }
  }

  window.location.href = "/login";
}
